import { Http } from "../Http";
export class jobscheduleAPI {
 
  public static  getJobschedule(input: any){

    var url = "api/schedulerJobsRepository/" + input;
    if (input === "") {
      return { data: [] };
    }

    const resultMethod = Http.axios()
      .get(url, {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
        }
      })
      .then(res => {
        return res;
      })
      .catch((e: any) => {
        return e.response;
      });
    return resultMethod;
   
  }

    public static saveJobschedule(input: any) {
     
        var obj=JSON.stringify(input);
        var url="api/saveSchedulerJobsRepository";
        if(input.jobId>0 ){
            url="api/updateSchedulerJobsRepository";
        }
       
        const resultMethod = Http.axios().post(url, obj,
          {
            headers: {
              'Content-Type': 'application/json',
              "Access-Control-Allow-Origin": "*",
              "Access-Control-Allow-Methods": "*",
              "Access-Control-Allow-Headers": "*"
            }
          })
          .then(res => {
   
            return res;
          }).catch((e: any) => {
          
            return e.response;
          });
        return resultMethod;
}

public static DeleteJobschedule(input: any) {
  return {data: "ture"};
}
}